import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Nav from './Nav';
import Footer from './Footer';

export default function Layout({ children }) {
  const { pathname } = useLocation();

  // Scroll to top on route change (don't fight in-page hash navigation on /)
  useEffect(() => {
    if (!window.location.hash) {
      window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
    }
  }, [pathname]);

  return (
    <div className="min-h-screen text-gray-900 flex flex-col" style={{ backgroundColor: '#fbfcf3' }}>
      <Nav />
      <main className="flex-1 pt-24">{children}</main>
      <Footer />
    </div>
  );
}
